import { Component, Input, OnInit } from '@angular/core';
import { WidgetsEntity } from 'src/app/models/widget-entity.model';

@Component({
  selector: 'app-frame',
  templateUrl: './frame.component.html',
  styleUrls: ['./frame.component.scss']
})
export abstract class FrameComponent implements OnInit{
  
  @Input() widgets?: (WidgetsEntity | null)[] | null;

  protected abstract init(): void;

  ngOnInit(): void {
    this.init();
  }
}
